import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IReactor } from 'src/app/storage/interfaces/reactor.interface';
import { Mission } from 'src/app/storage/models/mission.model';
import { Reactor } from 'src/app/storage/models/reactor.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST + 'reactors';

@Injectable({
  providedIn: 'root'
})
export class ReactorsService {

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getMissionReactors(mission: Mission): Promise<Reactor[] | null> {
    const translations = await this.translateService.get('REACTORS').toPromise();

    const response = await this.apiService.get(
      `${URL}/mission/${mission.missionId}`,
      translations['LABEL'],
      { showLoader: true }
    );

    return response ?
          response.reactors.map((reactor: IReactor) => new Reactor(reactor)) :
          null;
  }
}
